import React from 'react';
import {
  InputFileContainer,
  InputFileField,
  InputFileLabel,
  InputFileContent,
  InputFileDescription
} from './styles';
import { BsCloudUpload } from 'react-icons/bs';
import InputFileLoaderPreviewItemBackGroundImage from '../InputFileLoaderPreviewItemBackGroundImage'
import colors from '../../assets/styles/colors';

const InputFileBackGroundImage = ({ getInputProps, getRootProps, canAddFile, removeFile, files, description, id }) => {
  return (
    <InputFileContainer id="input-file">
      {files.map((item, key) => (
        <InputFileLoaderPreviewItemBackGroundImage item={item} key={key} id={key} removeFile={removeFile} />
      ))
      }
      <InputFileLabel {...getRootProps()} htmlFor="inputFile" id={id}>
        <InputFileContent canAddFile={canAddFile}>
          <BsCloudUpload color={colors.grayLight} size={48} id="cloud-upload-icon" />
          <InputFileDescription>{description}</InputFileDescription>
        </InputFileContent>
      </InputFileLabel>
      <InputFileField {...getInputProps()} disabled={!canAddFile} multiple={false} id="file" />
      
    </InputFileContainer >
  )
}

export default InputFileBackGroundImage
